<template>
  <div
      class="position-relative w-100 h-100"
      :class="bgLayoutMap[props.effectMode]"
      :style="{
        maxWidth:`${defaultWidth}px`,
        maxHeight:`${defaultHeight}px`
      }"
  >
    <div class="text_wrap"
         :class="[
             horizontalPosition[textLayoutData.obj.HorizontalAlignment],
             verticalPosition[textLayoutData.obj.VerticalAlignment],
            { 'center d-flex align-items-center justify-content-evenly': textLayoutData.obj.HorizontalAlignment === 'Center' && textLayoutData.obj.VerticalAlignment === 'Center' },
            ]"
         :style="{
            textShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`,
            opacity: `${textOpacity}`
           }"
    >
      <div
          class="d-inline-flex flex-column"
          :class="columnTextAlign[textLayoutData.obj.TextAlignment]"
      >
        <div
            class="
              top_font_wrap
              sub_font_size
              sub_font_family
              top_margin_fix
              d-inline-flex
              align-items-center
              flex-nowrap
            "
            :class="[
                  props.effectMode === 'Blossom' ? 'justify-content-between' : 'justify-content-evenly',
                  `sub_font_family_${props.effectMode}_${textType}`,
                  `sub_font_size_${props.effectMode}_${textType}`,
                  `top_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
            :style="{ 'color': changeToRgba(textLayoutData.obj.FontColors[0]) }"
        >
            <span
                v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
                class="d-inline-block me-2 blossom_custom_space"
                :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_start' : ''"
                :style="{
                  backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[0]),
                  boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                }"
            />
          <span class="sub_letter_space" :class="[`sub_letter_space_${props.effectMode}_${textType}`]">{{ nowDateTimeObjComputed.obj.date }}</span>
          <span
              v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
              class="d-inline-block ms-2 blossom_custom_space"
              :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_end' : ''"
              :style="{
                  backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[0]),
                  boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                }"
          />
        </div>
        <div
            class="
             medium_font_wrap
             main_font_size
             d-inline-flex
             align-items-center
             flex-nowrap
            "
            :class="[
                  props.effectMode === 'Blossom' ? 'justify-content-between' : 'justify-content-evenly',
                  mainFontFamily,
                  `main_font_size_${props.effectMode}_${textType}`,
                  ]"
            :style="{
            'color': changeToRgba(textLayoutData.obj.FontColors[1]),
          }"
        >
          <span class="main_letter_space" :class="[`main_letter_space_${props.effectMode}_${textType}`]">{{ nowDateTimeObjComputed.obj.time }}</span>
        </div>
        <div
            class="
              bottom_font_wrap
              bottom_margin_fix
              sub_font_size
              sub_font_family
              d-inline-flex
              align-items-center
              flex-nowrap
            "
            :class="[
                    props.effectMode === 'Blossom' ? 'justify-content-between' : 'justify-content-evenly',
                    `sub_font_family_${props.effectMode}_${textType}`,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `sub_letter_space_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
            :style="{ 'color': changeToRgba(textLayoutData.obj.FontColors[2]) }"
        >
            <div
                v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
                class="d-inline-block me-2 blossom_custom_space"
                :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_start' : ''"
                :style="{
                  backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[2]),
                  boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                }"
            />
          <div class="sub_letter_space" :class="[`sub_letter_space_${props.effectMode}_${textType}`, timeLowercase.indexOf(props.effectMode) >= 0 ? 'text_lowercase' : '']"> {{ nowDateTimeObjComputed.obj.timeMode }}</div>
          <div
              v-if="props.effectMode === 'Blossom' || props.effectMode === 'RainbowShoot'"
              class="d-inline-block ms-2 blossom_custom_space"
              :class="props.effectMode === 'RainbowShoot' ? 'rainbow_shoot_arrow_end' : ''"
              :style="{
                backgroundColor: props.effectMode === 'RainbowShoot' ? 'transparent' : changeToRgba(textLayoutData.obj.FontColors[2]),
                boxShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`
                }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import moment from "moment"
import defaultValue from "@/utils/defaultValue";
import textModeTool from "@/utils/textModeTool";

import {ref, reactive, computed, watchEffect, onUnmounted} from 'vue'
import changeToRgba from '@/utils/globalFunc'

const {defaultWidth, defaultHeight} = defaultValue()
const {
  bgLayoutMap,
  horizontalPosition,
  verticalPosition,
  columnTextAlign,
  initMainFontFamily
} = textModeTool()

const props = defineProps(["textData", 'effectMode'])
const texts = reactive(props.textData)
const textType = ref('')
const textLayoutData = reactive({obj: {}})
const controllerLoopSecond = ref(0)
const mainFontFamily = ref('')

const nowDateTimeObj = reactive({obj: {}})
const nowDateTimeObjComputed = computed(()=> {
  return nowDateTimeObj
})
const timeLowercase = reactive(['Image', 'Color', 'Blossom', 'TwistHole', 'Snow'])
const timeTiger = ref(null)
function startTime() {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('YYYY/MM/DDThh:mmTA').split('T')
  const timeTextObj = {
    date: nowDate[0], // 日期
    time: nowDate[1], // 時間
    timeMode: nowDate[2] === 'AM' ? `A.M.` : `P.M.`
    // todo AM/PM 大小寫
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 500)
}

const textShadow = ref('35%')
const textOpacity = ref('100%')

watchEffect(() => {
  const {
    Type,
    Layout
  } = texts
  if (timeTiger.value) clearTimeout(timeTiger.value)

  if (Type === 'None' || Type === undefined) {
    textLayoutData.obj = {}
    return false
  }

  // Type 文字模式
  textType.value = Type
  // effectMode effect模式


  // 取得文字對齊位置
  Object.assign(textLayoutData.obj, Layout[0])

  const {
    Shadow,
    Opacity,
    FontFamily
  } = Layout[0]
  textShadow.value = parseInt(Shadow) >= 0 ? `${Shadow}%` : '35%'
  textOpacity.value = parseInt(Opacity) >= 0 ? `${Opacity}%` : '100%'
  if (FontFamily && FontFamily !== '') mainFontFamily.value = `font_family_${FontFamily}`
  else mainFontFamily.value = initMainFontFamily(props.effectMode)
  startTime()
})

onUnmounted(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
})
</script>
